import axios from "axios";
import { TokenManager } from "../api/utils/tokenManager";

/**
 * Gerenciador centralizado de token para todas as APIs
 * Garante que o token seja configurado tanto no sistema novo (apiClient)
 * quanto no sistema legado (axios.defaults)
 */
class TokenManagerHelper {
  /**
   * Configura o token globalmente para todas as instâncias do axios
   */
  static setAuthToken(token: string): void {
    // 1. Configurar no sistema novo (TokenManager para apiClient)
    // Nota: TokenManager salva em localStorage com chave "accessToken"
    TokenManager.setToken(token);

    // 2. Configurar no sistema legado (axios.defaults para helpers antigos)
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  /**
   * Remove o token de todas as instâncias do axios
   */
  static clearAuthToken(): void {
    // 1. Limpar do sistema novo
    TokenManager.clearToken();

    // 2. Limpar do sistema legado
    delete axios.defaults.headers.common["Authorization"];
  }

  /**
   * Verifica se há token configurado
   */
  static hasToken(): boolean {
    return TokenManager.hasToken();
  }

  /**
   * Obtém o token atual
   */
  static getToken(): string | null {
    return TokenManager.getToken();
  }

  /**
   * Obtém o token com prefixo Bearer
   */
  static getBearerToken(): string | null {
    return TokenManager.getBearerToken();
  }

  /**
   * Obtém o token sem o prefixo Bearer
   */
  static getCleanToken(): string | null {
    return TokenManager.getCleanToken();
  }

  /**
   * Inicializa o token a partir do localStorage ao carregar a aplicação
   */
  static initializeFromStorage(): void {
    const token = TokenManager.getToken();

    if (token) {
      // Configurar no sistema legado (o novo já é configurado pelos interceptors)
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }
}

export { TokenManagerHelper };
export default TokenManagerHelper;
